import type { ConditionContext } from "@appcraft/common-utils";
import { AllFieldTypes } from "../types/feedbackFields.types";
import { isValidCondition } from "./object.utils";

type User = Record<string, any>;
type Data = Record<string, any>;

function filterVisibleBy<T extends { visibleBy?: ConditionContext }>(
  items: T[] | undefined,
  user: User,
  data: Data
): T[] | undefined {
  if (!items) return undefined;
  return items.filter((item) => isValidCondition(item.visibleBy, user, data));
}

export const filterVisibleByFields = (FeedbackForm: AllFieldTypes[], user: User, data: Data): any => {
  return FeedbackForm.filter((field) => isValidCondition(field.condition || field.visibleBy, user, data)).map(
    (field) => {
      if (
        field.type === "single_choice" ||
        field.type === "matrix" ||
        field.type === "multiple_choice" ||
        field.type === "select"
      ) {
        return {
          ...field,
          // @ts-ignore
          choices: filterVisibleBy(field.choices, user, data),
          lines: filterVisibleBy((field as any).lines, user, data),
        };
      }
      return field;
    }
  );
};
